// extracted by mini-css-extract-plugin
export var chevron = "_c1-2";
export var dropdownItems = "_c1-0";
export var item = "_c1-1";